<template>
  <MainLayout>
    <ContentPageHeader functionName="売上管理" pageName="売上出力">
    </ContentPageHeader>

    <div class="search-section">
      <div class="search-form">
        <FormRadioField 
          label="" 
          id="tableType" 
          v-model="selectedType"
          :options="tableTypeOptions"
          :show-label="false"
          :show-required="false"
        />
        
        <FormSelectSearchField 
          label="対象店舗" 
          id="storeId" 
          v-model="storeId"
          :options="storeOptions"
          required
          size="small"
        />
        
        <FormDateField 
          label="対象年月" 
          id="salesDate" 
          v-model="salesDate"
          type="month"
          required
          size="medium"
        />
      </div>
    </div>
    <template #footer-buttons>
      <button class="btn btn-primary" @click="downloadData">ダウンロード</button>
    </template>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layout/MainLayout.vue'
import ContentPageHeader from '@/components/layout/ContentPageHeader.vue'
import FormSelectSearchField from '@/components/form/FormSelectSearchField.vue'
import FormDateField from '@/components/form/FormDateField.vue'
import FormRadioField from '@/components/form/FormRadioField.vue'
import { showLoading, hideLoading } from '@/utils/loadingEventBus'
import service from '@/services/service'

export default {
  name: 'SalesManagementView',
  components: {
    MainLayout,
    ContentPageHeader,
    FormSelectSearchField,
    FormDateField,
    FormRadioField
  },
  data() {
    return {
      // 選択されたテーブルタイプ(デフォルトは店舗別売上管理表)
      selectedType: 1,
      // テーブルタイプオプション
      tableTypeOptions: [
        { value: 1, label: '店舗別売上管理表' },
        { value: 2, label: '店舗売上表' }
      ],
      // 選択店舗
      storeId: '',
      // 売上年月
      salesDate: '',
      // 店舗オプション
      storeOptions: [],
    }
  },
  created() {
    this.fetchStoreList()
  },
  methods: {
    // 店舗一覧を取得
    async fetchStoreList() {
      try {
        showLoading();
        const response = await service.getStoreList();
        this.storeOptions = response.data.stores.map(store => ({
          value: store.id,
          label: store.storeName
        }));
      } catch (error) {
        console.error('店舗一覧の取得に失敗しました', error);
        alert('店舗一覧の取得中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
    // ダウンロード処理
    async downloadData() {
      // バリデーションチェック
      if (!this.storeId) {
        alert('対象店舗は必須です');
        return;
      }
      if (!this.salesDate) {
        alert('対象年月は必須です');
        return;
      }
      // 選択された内容でダウンロード処理を実行
      try {
        showLoading();

        const request = {
          selectedType: this.selectedType,
          storeId: this.storeId,
          salesDate: this.salesDate
        };
        
        const response = await service.exportSalesCSV(request);

        // Blobオブジェクトを作成
        const blob = new Blob([response.data], { type: 'text/csv;charset=shift_jis' });
        
        // ダウンロードリンクを作成
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        
        // ファイル名を設定
        // 選択された店舗名を取得
        const selectedStore = this.storeOptions.find(store => store.value === this.storeId);
        const storeName = selectedStore ? selectedStore.label : '';
        
        // 選択された年月をYYYYMM形式で取得
        const selectedDate = new Date(this.salesDate);
        const selectedYear = selectedDate.getFullYear();
        const selectedMonth = String(selectedDate.getMonth() + 1).padStart(2, '0');
        const formattedDate = `${selectedYear}${selectedMonth}`;
        
        // selectedTypeに基づいてファイル名を設定
        if (this.selectedType === 1) {
          a.download = `${storeName}_${formattedDate}_店舗別売上管理表.csv`;
        } else {
          a.download = `${storeName}_${formattedDate}_店舗売上表.csv`;
        }
        
        // リンクをクリックしてダウンロード
        document.body.appendChild(a);
        a.click();
        
        // リンクを削除
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error('ダウンロードに失敗しました', error);
        alert('ダウンロード中にエラーが発生しました。');
      } finally {
        hideLoading();
      }
    },
  }
}
</script>

<style scoped>
</style>
